import request from '@nineeng/request';
import { AuthenticationSession, User } from '@repo/shared/domain';
let defaultExperience: 'legacy' | '2.0' | undefined = undefined;
export async function getAuthenticatedSession() {
	const response = await request.get<AuthenticationSession>(`/api/auth/session`);
	return response.body;
}

export async function getCurrentUser() {
	const response = await request.get<User>(`/api/auth/current-user`);
	return response.body;
}

export async function logout() {
	const response = await request.post<void>(`/api/auth/logout`, {});
	return response.body;
}

export async function checkSSOAvailable() {
	const response = await request.get(`/api/auth/sso/check`);
	return response.body as { ssoAvailable: boolean };
}

export async function getDefaultExperience(): Promise<'legacy' | '2.0'> {
	try {
		if (!defaultExperience) {
			const res = await request.get<{ defaultAdminExperience?: 'legacy' | '2.0' }>('/api/public/default-experience');
			defaultExperience = res.body?.defaultAdminExperience || 'legacy';
		}
		return defaultExperience;
	} catch {
		return 'legacy';
	}
}

export async function checkRequest(id: string, check: string): Promise<boolean> {
	try {
		const response = await fetch(`/api/auth/reset-password-request/${id}?key=${check}`);
		return response.status === 200;
	} catch {
		return false;
	}
}
